// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* TAG STATUS */\n/* VIEW */\n.ia-search-divider {\n  -ms-flex-item-align: stretch;\n      align-self: stretch;\n  border-left: 1px solid #dddcdc;\n  margin: 4px 8px 0px 16px;\n  width: 1px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
